import React, { useState, useEffect, useContext } from "react";
import { fondo } from '../providers';
import Header from "../modules/Header";
import { UserContext } from "../context/UserContext";



function CompraX() {
    const [user, _] = useContext(UserContext);
    const [Compras, setCompras] = useState([]);


    const [nombre, setNombre] = useState("");
    const [codigo, setCodigo] = useState("");
    const [tipo, setTipo] = useState("0");
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const getFacturaCompra = async () => {
        await fetch("https://app-mcewan.herokuapp.com/xubio/getFacturaCompra",
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "access_token": user.tokenXubio
                })
            })
            .then(response => response.json())
            .then((value) => setCompras(value))
            .catch(error => console.log(error));
    }

    useEffect(() => {
        (async () => {
            await getFacturaCompra();
        })();
    }, [user.tokenXubio]);


    return (
        <div className="container_general">
            <img src={fondo} className='fondo' alt='mcewanfondo' />
            <Header />
            <div className="body_container">
                <div className="general-filters">
                    <form>
                        <div className="form-group">
                            <p>Nombre Proveedor</p>
                            <div className="input-case">
                                <input type="text" className="search_input"
                                    value={nombre} onChange={(value) => setNombre(value.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Codigo Transaccion</p>
                            <div className="input-case">
                                <input type="text" className="search_input"
                                    value={codigo} onChange={(value) => setCodigo(value.target.value)}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Tipo</p>
                            <div className="input-case">
                                <select className="search_input"
                                    value={tipo} onChange={(value) => setTipo(value.target.value)}
                                >
                                    <option value={"0"}>Todos</option>
                                    <option value={"1"}>Factura</option>
                                    <option value={"2"}>Nota de débito</option>
                                    <option value={"3"}>Nota de credito</option>
                                    <option value={"6"}>Recibo</option>
                                    <option value={"99"}>Otro</option>

                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <p>Fecha Desde</p>
                            <div style={{ width: '32%' }} className="input-case">
                                <input type="date" className="search_input"
                                    value={dateFrom} onChange={(value) => setDateFrom(value.target.value)}
                                />

                            </div>
                            <p>Fecha Hasta</p>
                            <div style={{ width: '32%' }} className="input-case">
                                <input type="date" className="search_input"
                                    value={dateTo} onChange={(value) => setDateTo(value.target.value)}
                                />

                            </div>
                        </div>
                    </form>
                </div>
                <div className="table_card">
                    <table>
                        <tr>
                            <th>Codigo Transaccion</th>
                            <th>Proveedor</th>
                            <th>Cotización</th>
                            <th>Fecha</th>
                            {/*<th>Fecha Comprobante</th>*/}
                            <th>Importe Gravado</th>
                            <th>Importe Impuestos</th>
                            <th>Importe Principal</th>
                            <th>moneda</th>
                            <th>Numero Documento</th>
                            <th>Tipo</th>

                        </tr>
                        {console.log(Compras),
                            Compras.length > 1 ? (
                                Compras.filter((val) => {
                                    if (nombre === "") {
                                        return val;
                                    } else if (val.proveedor.nombre.toLowerCase().includes(nombre.toLowerCase())) {
                                        return val;
                                    }
                                }
                                ).filter((val) => {
                                    if (codigo === "") {
                                        return val;
                                    } else if (val.transaccionid.toString().includes(codigo)) {
                                        return val;
                                    }
                                }).filter((val) => {
                                    if (tipo === "0") {
                                        return val;
                                    } else if (tipo===val.tipo.toString()) {
                                        return val;
                                    }
                                }).filter((val) => {
                                    let dateCheck;
                                        let tsDate;
                                        let tsDateTo;
                                        tsDateTo = Date.parse(dateTo);
                                        tsDate = Date.parse(dateFrom);
                                        dateCheck = Date.parse(val.fecha)
                                        if (dateFrom === undefined || dateTo === undefined) {
                                            return val;
                                        } else if (dateCheck >= tsDate && dateCheck <= tsDateTo) {
                                            return val;
                                        }
                                }).map((value, index) => {
                                    var tipoDisplay;

                                    switch (value.tipo) {
                                        case 1:
                                            tipoDisplay = "Factura";
                                            break;
                                        case 2:
                                            tipoDisplay = "Nota de débito";
                                            break;
                                        case 3:
                                            tipoDisplay = "Nota de credito";
                                            break;
                                        case 6:
                                            tipoDisplay = "Recibo";
                                            break;
                                            case 99:
                                            tipoDisplay = "Otro";
                                            break;

                                    }
                                    if (value.moneda.nombre === 'Dólares') {
                                        value.moneda.nombre = 'USD'
                                    }
                                    if (value.moneda.nombre === 'Pesos Argentinos') {
                                        value.moneda.nombre = 'ARS'
                                    }
                                    return (
                                        <tr key={index}>
                                            <td>{value.transaccionid}</td>
                                            <td>{value.proveedor.nombre}</td>
                                            <td>{value.cotizacion}</td>
                                            <td>{value.fecha}</td>
                                            {/*<td>{value.fechaComprobante}</td>*/}
                                            <td>{value.importeGravado}</td>
                                            <td>{value.importeImpuestos}</td>
                                            <td>{value.importeMonPrincipal}</td>
                                            <td>{value.moneda.nombre}</td>
                                            <td>{value.numeroDocumento}</td>
                                            <td>{tipoDisplay}</td>

                                        </tr>
                                    );
                                })
                            ) : null

                        }
                    </table>
                </div>
            </div>
        </div>
    );
}

export default CompraX;